<template>
  <div class="base-header">
    <div class="w1200">
      <div class="title">
        <img v-if="lang === 'zh'" src="../../deps/public/logo1.png" height="64" alt="" @click="jumpOffice('zh')">
        <img v-else src="../../deps/public/logo.png" alt="" @click="jumpOffice('en')">
        <el-dropdown class="title-line">
          <el-button type="primary" @click="loginFn">{{!(userData && userData.token)?$i18n.t('login'):$i18n.t('loginOut')}}</el-button>
          <el-dropdown-menu style="visibility:hidden"></el-dropdown-menu>
        </el-dropdown>
        <a href="javascript:;" :class="{actived: lang === 'en'}" >{{!(userData && userData.token)? '请登录':userData.mobilePhone}}</a>
      </div>
    </div>
    <div class="banner" v-if="lang === 'zh'"></div>
    <div class="banner banner1" v-else></div>
    <div class="links" ref="links">
      <div class="w1200">
        <!-- <span>{{ $i18n.t('asw') }}</span> -->
        <div class="ul-btn">
          <el-button type="text" v-for="m in links" :key="m.value" @click="routeGo({name: m.name})" :class="{'actived': $route.name === m.name}">{{$i18n.t(m.label)}}</el-button>
        </div>
      </div>
    </div>
      <el-dialog
        :title="$i18n.t('tip')"
        :visible.sync="dialogVisible"
        :modal="true"
        :show-close="false"
        width="410px"
        center
        class="buy-dialog login-dialog">
        <el-button type="primary" @click="$router.push({name:'login', query: { name: routeParams }})">{{ $i18n.t('goLogin') }}</el-button>
        <!-- <span>{{ $i18n.t('buyDesc') }}</span> -->
        <span slot="footer" class="dialog-footer">
          <el-button type="text" @click="dialogVisible=false">{{ $i18n.t('cancelBtn') }}</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
import { setup } from '@/widgets/i18n'
import { loginOut } from '@/deps/apis/login'
export default {
  computed: {
  },
  data() {
    return {
      dialogVisible: false,
      userData: JSON.parse(sessionStorage.getItem('userData')),
      lang: 'zh',
      userName: '',
      dropdown: [
        // {
        //   label: this.$i18n.t('changeEmail'),
        //   fn: () => { this.$router.push({name: 'email'}) }
        // },
        // {
        //   label: this.$i18n.t('changePassword'),
        //   fn: () => { this.$router.push({name: 'password'}) }
        // },
        // {
        //   label: this.$i18n.t('personal'),
        //   fn: () => { this.$router.push({name: 'personal'}) }
        // },
        {
          label: this.$i18n.t('loginOut'),
          fn: this.loginout
        }
      ],
      links: [
        {
          name: 'yanbao-search',
          label: 'active'
        },
        {
          name: 'yanbao-buy',
          label: 'search'
        },
        {
          name: 'yanbao-active',
          label: 'buy'
        },
        // {
        //   name: 'yanbao-complaint',
        //   label: 'complaint'
        // },
        {
          name: 'yanbao-personal',
          label: 'personal'
        }
      ],
      routeParams: null
    }
  },
  methods: {
    loginout() {
      loginOut().then(res => {
        sessionStorage.clear()
        this.userData = JSON.parse(sessionStorage.getItem('userData'))
        this.$router.push({name: 'yanbao-search'})
        // this.$nextTick(() => {
        //   location.reload();
        // })
      })
    },
    loginFn() {
      if (this.userData && this.userData.token) {
        this.loginout();
      } else {
        this.$router.push({name: 'login'})
      }
    },
    changeL(lang) {
      if (this.lang === lang) return
      this.lang = lang
      setup(lang)
      location.reload()
      window.document.title = this.lang === 'zh' ? '爱士惟延保' : 'Aiswei Warranty'
    },
    jumpOffice(lang) {
      if (this.lang === 'zh') {
        location.href = 'https://www.aiswei-tech.com/';
      } else {
        location.href = 'https://en.aiswei-tech.com/';
      }
    },
    routeGo(to) {
      if (this.userData && this.userData.token) { this.$router.push(to); return }
      this.routeParams = to.name;
      switch (to.name) {
        case 'yanbao-buy':
          this.dialogVisible = true;
          break;
        case 'yanbao-personal':
          this.dialogVisible = true;
          break;
        case 'yanbao-active':
          this.dialogVisible = true;
          break;
        default:
          this.$router.push(to)
          break;
      }
    },
    scrollToOption() {
      const reference = this.$refs.links.$el || this.$refs.links;
      console.log(document.body.clientHeight, window.screen.availHeight, window.screen.height, window.innerHeight)
      if (window.innerHeight <= 768) {
        setTimeout(function () { reference.scrollIntoView(true); }, 100)
      }
    }
  },
  watch: {
    $route(to, from) {
      // let userData = JSON.parse(sessionStorage.getItem('userData'));
      // if (userData && userData.token) { return }
      // switch (to.name) {
      //   case 'yanbao-buy':
      //     this.dialogVisible = true;
      //     break;
      //   case 'yanbao-personal':
      //     this.dialogVisible = true;
      //     break;
      // }
    }
  },
  created() {
    this.lang = window.localStorage.getItem('localeLanguage') || 'zh';
    window.document.title = this.lang === 'zh' ? '爱士惟延保' : 'Aiswei Warranty'
    // let userData = JSON.parse(sessionStorage.getItem('userData'))
    // !userData ? this.$router.push({name: 'login'}) : this.userName = userData ? userData.userName : ''
  },
  mounted() {
    this.scrollToOption();
  }
}
</script>
<style lang="stylus">
.header-drop
  top 80px!important
.base-header
  width 100%
  background #fff
  .login-dialog
    .el-dialog
      margin: 450px auto 0 !important;
  .title
    height 115px
    line-height 115px
    position relative
    img
      margin-top 25px
      max-width 239px
      max-height 64px
    a
      float right
      margin-left 15px
      font-size 18px
      font-weight bold
      color #333
    .el-dropdown
      float right  
      margin-left 40px
      cursor pointer
    .actived
      color #EA5413
  .banner
    height 160px
    background url('../../deps/public/home.png') no-repeat center center
    background-size cover
  .banner1
    background url('../../deps/public/home1.png') no-repeat center center
    background-size cover
  .links
    padding 60px 0 32px 0
    border-bottom 1px solid #dadada
    box-shadow 0px 1px 4px 0px rgba(0,21,41,0.12)
    .w1200
      overflow hidden
      line-height 36px
      & > span
        font-size 24px
        font-weight normal
        color rgba(153,153,153,1)
    .ul-btn
      float right
      .el-button
        color #333333
        font-size 18px
        margin-left 66px
        &:hover
          color #EA5413
      .actived
        color #EA5413 
  .title-line
    width:105px;
    .el-button
      padding 6px 10px
    &:before
      content: '';
      display: block;
      position: absolute;
      right: 125px;
      top: 47px;
      width: 2px;
      height: 20px;
      background: #1e2958;
</style>


// WEBPACK FOOTER //
// src/modules/baseHeader/index.vue